module.exports = __webpack_public_path__ + "img/b.008919e9.jpg";